
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"67","height":"78","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.7 65.443l-.586-.586H7.43c-3 0-5.429-2.429-5.429-5.428v-52C2 4.429 4.429 2 7.429 2h52c3 0 5.428 2.429 5.428 5.429v52c0 3-2.429 5.428-5.428 5.428H43.742l-.586.586-9.728 9.729-9.73-9.73z","stroke":"#BEC2C9","stroke-width":"4"}}),_c('path',{attrs:{"d":"M33.337 12C26.534 12 21 17.534 21 24.337a2.868 2.868 0 005.735 0 6.609 6.609 0 016.602-6.602 6.609 6.609 0 016.6 6.602 6.609 6.609 0 01-6.6 6.6 2.868 2.868 0 00-2.868 2.868v6.484a2.868 2.868 0 005.735 0v-3.952c5.424-1.296 9.47-6.185 9.47-12C45.673 17.533 40.138 12 33.336 12zM33.337 54.05a4.015 4.015 0 100-8.029 4.015 4.015 0 000 8.03z","fill":"#BEC2C9"}})])
          )
        }
      }
    